export const enum TaskStatus {
  in_progress = 'in_progress',
  to_do = 'to_do',
  done = 'done',
  cancelled = 'cancelled',
}
